import PageTitle from "../../components/PagesComponents/PageTitleSection/PageTitle";

const OurGoal = () => {
  return (
    <><PageTitle pagetitle="OUR GOAL" />
    <div className=''>
      
      
    </div></>
  )
}

export default OurGoal